import React from "react";

import { useTranslation } from "react-i18next";

import { BookingTemplateFormTypes } from "@assets/formTypes";

type PartnerAddressCardInfoProps = {
  partner: BookingTemplateFormTypes.PartnerForm;
};

const PartnerAddressCardInfo = ({ partner }: PartnerAddressCardInfoProps) => {
  const { t } = useTranslation();

  return (
    <span>
      <p className="font-bold text-neutral-900">{partner.CompanyName}</p>
      <p className="text-neutral-900">{partner.StreetAndNumber}</p>
      <p className="text-neutral-900">
        {partner.PostalCode} {partner.City}
      </p>
      <p className="text-neutral-900">{partner.Country}</p>
      <br />
      <p>
        <span>{`${t("LABEL_CONTACT_PERSON")}: `}</span>
        <span className="text-neutral-900">
          {partner.ContactName || t("TEXT_NOT_PROVIDED")}
        </span>
      </p>
      <p className="truncate">
        <span>{`${t("LABEL_EMAIL")}: `}</span>
        <span className="text-neutral-900">
          {partner.Email || t("TEXT_NOT_PROVIDED")}
        </span>
      </p>
      <p>
        <span>{`${t("LABEL_PHONE")}: `}</span>
        <span className="text-neutral-900">
          {partner.Phone || t("TEXT_NOT_PROVIDED")}
        </span>
      </p>
    </span>
  );
};

export default PartnerAddressCardInfo;
